import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(2),
    },
    button: {
      width: '100%',
    },
  }),
  { name: 'CreateContentItem' }
);
